import useTableQuery from '@/hooks/useTableQuery';
import { getSchemeLis } from '@/services/myPlan';
import { useParams, useModel } from '@umijs/max';
import { useEffect  } from 'react'

export default () => {
  const { pageId } = useModel('AssistantInfo.assistantInfo')
  const {
    setQueryData,
    resetPage,
    pageChange,
    Loading,
    result,
    total,
    current,
    size,
    handles,
  } = useTableQuery(getSchemeLis, {
    serchData: {
      keywords: '',
      pageNum: 1,
      pageSize: 12,
      timeOrder: 'desc',
    },
    size: 12,
    debounceInterval: 500,
    throttleInterval: 0
  });

  return {
    setQueryData,
    resetPage,
    pageChange,
    Loading,
    result,
    total,
    current,
    size,
    handles,
  };
};
